import { StyleSheet, Platform } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: theme => ({
    backgroundColor: theme.name === 'light' ? theme.colors.backgroundColor : null,
  }),
  scrollContainer: withTray => ({
    marginHorizontal: 16,
    paddingBottom: withTray ? (Platform.OS === 'android' ? 150 : 120) : 30,
  }),
  headerText: {
    ...Fonts.type.bold,
    fontSize: 24,
    lineHeight: 32,
    marginTop: 25,
  },
  priceValue: {
    fontSize: 18,
    lineHeight: 28,
    ...Fonts.type.bold,
  },
  durationText: {
    fontSize: 18,
    lineHeight: 28,
    paddingTop: Platform.OS === 'ios' ? 2 : 0,
    marginLeft: 4,
  },
  descriptionText: {
    fontSize: 16,
    lineHeight: 20,
    marginTop: 16.6,
  },
  secondaryButton: {
    marginTop: 18.5,
  },
  priceContainer: {
    marginVertical: 16.6,
    flexDirection: 'row',
  },
  rowText: {
    fontSize: 16,
    lineHeight: 20,
  },
  toggleContainerStyle: {
    margin: 0,
  },
  usersText: {
    ...Fonts.type.bold,
    fontSize: 24,
    lineHeight: 32,
  },
  description: theme => ({
    paddingBottom: 34,
    borderBottomColor: theme.colors.dividerTwo,
    borderBottomWidth: 1,
  }),
  rowStyle: theme => ({
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 13.54,
    borderBottomColor: theme.colors.dividerTwo,
    borderBottomWidth: 1,
  }),
  usersSectionStyle: theme => ({
    borderBottomColor: theme.colors.dividerTwo,
    borderBottomWidth: 1,
    paddingVertical: 18.5,
  }),
  usersContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8.3,
  },
  usersHintText: {
    fontSize: 16,
    lineHeight: 20,
  },
  addUserContainerStyle: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  addUserTextStyle: {
    fontSize: 16,
    lineHeight: 20,
    marginTop: Platform.OS === 'ios' ? 6 : 0,
  },
  addUserIconStyle: {
    marginLeft: 4,
  },
  priceInfoContainerStyle: theme => ({
    paddingVertical: 13.54,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomColor: theme.colors.dividerTwo,
    borderBottomWidth: 1,
  }),
  priceInfoTitleTextStyle: {
    ...Fonts.type.bold,
    fontSize: 16,
    lineHeight: 20,
  },
  priceInfoSubtitleTextStyle: {
    fontSize: 16,
    lineHeight: 20,
    marginTop: 8.33,
  },
  priceTextStyle: {
    fontSize: 32,
    lineHeight: 40,
    fontFamily: Fonts.type.VodafoneLt,
  },
  vatTextStyle: {
    fontSize: 14,
    lineHeight: 14.6,
    fontFamily: Fonts.type.VodafoneLt,
    textAlign: 'right',
    marginTop: 3.4,
  },
  titleStyle: {
    color: Colors.white,
  },
  subTitleLoadingStyle: {
    color: Colors.red,
  },
  buttonsContainerStyle: {
    marginTop: 33.75,
  },
});
